import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { nameof } from 'ts-simple-nameof';
import { DialogDataService } from '../../dialog/dialog-data.service';
import { DialogService } from '../../dialog/dialog.service';
import { QuestionDefinition, RichTextInputType, TextInputType } from '../../forms/form.types';
import { GenericFormGroupComponent } from '../../forms/generic-form-group.component';
import { AlertService } from '../../shared/services/alert.service';
import { ComponentText, TextService } from '../text.service';

@Component({
    selector: 'app-text-edit',
    templateUrl: './text-edit.component.html',
    styleUrls: ['./text-edit.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class TextEditComponent extends GenericFormGroupComponent implements OnInit {
    text: ComponentText;
    controls: {
        id: UntypedFormControl;
        alias: UntypedFormControl;
        formConfigurationAlias: UntypedFormControl;
        text: UntypedFormControl;
    };

    questions: {
        text: QuestionDefinition;
        alias: QuestionDefinition;
    };

    constructor(
        private textService: TextService,
        private dialogData: DialogDataService<ComponentText>,
        private dialogResponse: DialogService<ComponentText>,
        private alert: AlertService,
        protected renderer2: Renderer2
    ) {
        super(renderer2, true);
        this.text = dialogData.data;
        this.controls = {
            id: new UntypedFormControl(this.text.id),
            alias: new UntypedFormControl({ value: this.text.alias, disabled: this.text.alias }, Validators.required),
            formConfigurationAlias: new UntypedFormControl(this.text.formConfigurationAlias),
            text: new UntypedFormControl(this.text.text)
        };
        this.formGroup = new UntypedFormGroup(this.controls);
        this.questions = {
            text: {
                input: {
                    discriminator: 'RICH-TEXT',
                    control: this.controls.text,
                    property: nameof<ComponentText>((m) => m.text),
                    label: 'Text Content'
                } as RichTextInputType
            },
            alias: {
                input: {
                    discriminator: 'TEXT',
                    control: this.controls.alias,
                    property: nameof<ComponentText>((m) => m.alias),
                    required: true
                } as TextInputType
            }
        };
    }

    ngOnInit(): void {}

    save() {
        this.setSaving();
        this.textService.save(this.formGroup.getRawValue()).subscribe(
            (text) => {
                this.dialogResponse.send(this.dialogData, text);
                this.setDoneSaving();
                this.alert.toastSuccess();
            },
            () => {
                this.alert.toastError();
                this.setDoneSaving();
            }
        );
    }
}
